module.exports = __webpack_public_path__ + "static/thy-yeni-2-210b6755e76e9163595c85b4d5d3a06b.png";